module.exports = __webpack_public_path__ + "static/media/521.05d13478.webp";